/*
 * Collapses a long listing description to a few lines with a "See more"
 * toggle.
 *
 * The toggle is added only when the text actually overflows, so a two-line
 * description never shows a pointless control. Clamping is done in CSS; this
 * just measures and flips a class.
 */
(function () {
  'use strict';

  var EXPANDED = 'is-expanded';

  function overflows(body) {
    // scrollHeight exceeds clientHeight only while the clamp is applied.
    return body.scrollHeight - body.clientHeight > 2;
  }

  function initOne(root) {
    if (root.dataset.descriptionBound === 'true') return;
    root.dataset.descriptionBound = 'true';

    var body = root.querySelector('[data-description-body]');
    var toggle = root.querySelector('[data-description-toggle]');
    if (!body || !toggle) return;

    var labels = {
      more: toggle.textContent.trim(),
      less: toggle.getAttribute('data-label-less') || 'See less'
    };

    function sync() {
      var expanded = root.classList.contains(EXPANDED);
      // Only offer the toggle if collapsing would actually hide something.
      if (!expanded && !overflows(body)) {
        toggle.hidden = true;
        return;
      }
      toggle.hidden = false;
      toggle.textContent = expanded ? labels.less : labels.more;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      root.classList.toggle(EXPANDED);
      sync();
    });

    sync();

    // Re-measure once webfonts land, which changes the line count.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(function () {});
    }
    window.addEventListener('resize', sync);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-listing-description]');
    Array.prototype.forEach.call(roots, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
